import { Injectable } from '@angular/core';
import { AppEvent } from '@models/events/app-event.enum';
import { PurchaseContainer } from '@models/purchase-container.model';
import { Reservation } from '@models/reservation.model';
import { environment } from 'src/environments/environment';
import { EventBusService } from './event-bus.service';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

// In the /assets/js/fbPixel.js file
declare function initFBAnalytics(facebookPixelId: string): any;
declare const fbLogEvent: Function;
declare const processFbq: Function;

@Injectable({
  providedIn: 'root'
})
export class FacebookPixelService {
  allowed: boolean = false;
  fbId: string | undefined = environment.facebookPixelId;

  constructor(
    private eventBusService: EventBusService,
    private cookieService: NgcCookieConsentService
  ) { }

  init() {
    if (this.fbId && this.cookieService.hasConsented()) {
      initFBAnalytics(this.fbId);
      this.allowed = true;
      this.subscribeToEvents();
    }
  }

  private subscribeToEvents(): void {
    this.eventBusService.on(AppEvent.AddToCart, (reservation: Reservation) => {
      this.fbLogEvent(
        'AddToCart',
        reservation.total_price,
        reservation.event?.currency,
        reservation.items
      );
    });

    this.eventBusService.on(AppEvent.InitiateCheckout, (reservation: Reservation) => {
      this.fbLogEvent(
        'InitiateCheckout',
        reservation.total_price,
        reservation.event?.currency,
        reservation.items
      );
    });

    this.eventBusService.on(AppEvent.Purchase, (purchaseContainer: PurchaseContainer) => {
      this.fbLogEvent(
        'Purchase',
        purchaseContainer.order.amount,
        purchaseContainer.order.currency,
        purchaseContainer.reservation.items
      );
    });
  }

  fbPageView() {
    if (this.allowed) {
      if (typeof processFbq === "function") {
        processFbq('track', 'PageView');
      }
    }
  }

  // AddToCart, InitiateCheckout, Purchase
  fbLogEvent(name: string, total: string | number, currency: string | undefined, items: object): void {
    if (this.allowed) {
      if (typeof fbLogEvent === "function") {
        fbLogEvent(name, total, currency, items);
      }
    }
  }
}
